const BASE_TRIGGER_DEFAULT_GAP = 4;

export const BASE_TRIGGER_DEFAULT_ALIGN = {
	left: BASE_TRIGGER_DEFAULT_GAP,
	right: BASE_TRIGGER_DEFAULT_GAP,
	top: BASE_TRIGGER_DEFAULT_GAP,
	bottom: BASE_TRIGGER_DEFAULT_GAP,
} as const;
